import { ActivatedRoute } from '@angular/router';

export const getLastChildRoute = (activatedRoute: ActivatedRoute) => {
  let route = activatedRoute;
  while (route.firstChild) {
    route = route.firstChild;
  }

  return route;
};
